'use client';

import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { useEffect, useState } from 'react';
import { apiGetCaptcha } from '@/apis/captcha';

export const RecaptchaProvider = ({ children, domain }: { children: React.ReactNode; domain: string }) => {
    const [siteKey, setSiteKey] = useState<string | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        apiGetCaptcha(domain)
            .then(res => setSiteKey(res?.recaptcha_site_key ?? null))
            .catch(() => setSiteKey(null))
            .finally(() => setLoading(false));
    }, [domain]);

    if (loading) return null; // ← wait, don't mount children yet

    if (!siteKey) return <>{children}</>; // ← no key, render without captcha

    return (
        <GoogleReCaptchaProvider reCaptchaKey={siteKey}>
            {children}
        </GoogleReCaptchaProvider>
    );
};